import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject, observable, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LanguageService } from '@spartacus/core';
declare var gigya: any; 
declare global{
  interface Window {
    gigya: any;
    onGigyaServiceReady?: () => void;
  }
}
@Injectable({
  providedIn: 'root'
})
export class GigyaService implements OnInit {
  private sharedData = new BehaviorSubject<any>(null);
  // An observable stream that components can subscribe to
  public currentData: Observable<string> = this.sharedData.asObservable();
  private gigyaReadySubject = new BehaviorSubject<boolean>(false);
  public isGigyaReady$: Observable<boolean> = this.gigyaReadySubject.asObservable();
  lang: any;
  constructor(private languageservice: LanguageService) {
    console.log('GigyaService initialized');
    this.initialiseGigya();
    this.loadGigyaScript();
      this.languageservice.getActive().subscribe(res => {
        if(res=='zh'){
          this.lang = 'zh-cn';
        }
          console.log('Language set in GigyaService:', this.lang);
        })
   }
  ngOnInit(){
    this.languageservice.getActive().subscribe((res) => {
      this.lang = res;
    });
    console.log('GigyaService OnInit called');
  }
  

  private loadGigyaScript() {
    if (!document.getElementById('gigya-js')) {
      const script = document.createElement('script');
      script.id = 'gigya-js';
      script.type = 'text/javascript';
      script.src = environment.CDCLoginUrl;
      script.onload = () => {
        if (window.onGigyaServiceReady) {
          window.onGigyaServiceReady();
        }
      };
      document.body.appendChild(script);
    }
  }
  initialiseGigya() {
    // Always assign the callback, even if gigya is not loaded yet
    window.onGigyaServiceReady = () => {
      // gigya is now loaded
      this.gigyaReadySubject.next(true);
    };
    // If gigya is already loaded and ready (e.g., hot reload), trigger immediately
    if (window.gigya && window.gigya._ && window.gigya._.ready) {
      this.gigyaReadySubject.next(true);
    }
  }
   getCredentials():Promise<any>{
    return new Promise((resolve,reject) => {  
     gigya.accounts.auth.fido.getCredentials({
      callback: (response) => {
        if (response.errorCode === 0) {
          resolve(response);
          // observ.complete();
        } else {
          reject(response);
        }
      }
     });
    });
  }
   removeCredentials():Promise<any> {
    return new Promise((resolve,reject) => {
    gigya.accounts.auth.fido.getCredentials({
      lang:this.lang,
      callback: (response) => {
        if (response&& response.errorCode === 0 ) {
          if(!response.credentials || response.credentials.length == 0){
            reject({errorCode:403002,errorMessage:'No credentials found to remove'});
          }else{
             gigya.accounts.auth.fido.removeCredential({
            credentialId: response.credentials[0].Id,
            callback: (responseof) => {
              if(responseof.errorCode === 0){
                
                resolve(responseof);
              }else{
                reject(responseof);
              }
            },
          });
          }
         
        }else{
          reject(response);
        }
      },
    });
    })
   
  }
  login(userid,password): Promise<any> {
    return new Promise((resolve, reject) => {
      gigya.accounts.accounts.login({
        loginID:userid,
        password:password,
        lang:this.lang,
        "callback": (response) => {
          if (response.errorCode === 0) {
            resolve(response); 
          } else {
            reject(response);
          }
        }
      });
    });
  }
  fidoLogin(){
     return new Promise((resolve, reject) => {
      gigya.accounts.auth.fido.login({
        lang:this.lang,
        "callback": (response) => {
          if (response.errorCode === 0) {
            resolve(response); 
          } else {
            reject(response);
          }
        }
      });
    }); 
  }
  verifyLogin(): Promise<any> {
    return new Promise((resolve, reject) => {
      gigya.accounts.verifyLogin({
        lang:this.lang,
        "callback": (response) => {
          if (response.errorCode === 0) {
            resolve(response); 
          } else {
            reject(response);
          }
        }
      }); 
    });
  }

  showScreenSet(screenSetName: string, startScreen: string,deviceType:string): Promise<any> {
    return new Promise((resolve, reject) => {
      gigya.accounts.showScreenSet({
        screenSet: screenSetName,
        startScreen: startScreen,
        deviceType: deviceType,
        lang:this.lang,
        onAfterSubmit: (response) => {
          if (response.errorCode === 0) {
            resolve(response);
          } else {
            //reject(response);
          }
        },
        onScreenSetLoad: (response) => {
          resolve(response);
        },
        onError: (error) => {
          //reject(error);
        },
        onHide: (res) => {
          // Optionally resolve or reject here if you want to handle the user closing the screen set
          resolve({ closed: true, data: res });
        },
      });
    });
  }



  

  // Setter method to update the data
  setData(newData: any) {
    this.sharedData.next(newData);
  }

  // Getter method to get the current value (optional, can just use the observable)
  get getData(): string {
    return this.sharedData.value;
  }
}